import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';

import { FooterComponent } from './layout/footer/footer.component';
import { HeaderComponent } from './layout/header/header.component';
import { environment } from '@environments';

@Component({
    selector: 'app-root',
    imports: [RouterOutlet, HeaderComponent, FooterComponent],
    templateUrl: './app.component.html',
    styleUrl: './app.component.scss'
})
export class AppComponent {
  ngOnInit(): void {
    const domain = environment.production
      ? window.location.host
      : 'stg.concursoplus.com';

    if (domain) {
      sessionStorage.setItem(environment.storage + '-site', domain);
    }
  }
}
